import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Refunds.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListTranslationPage - Lazy-loaded ListRefundPage component.
 */
const ListRefund = Loadable(lazy(() => import("./ListRefundPage")));

/**
 * Array containing route definitions for the Refunds-related pages.
 * @constant {Object[]} RefundPageRoutes - Array of Refunds route objects.
 * @property {React.ReactElement} RefundPageRoutes[].element - The React element to be rendered for the Refunds route.
 */
const RefundPageRoutes = [
  {
    path: "list",
    element: <ListRefund />,
  },
];

export default RefundPageRoutes;
